module.exports = __webpack_public_path__ + "static/img/groundD2.aa612838.png";